import type { Subscription } from '../../../../../../../types';

function applyHourFilter(subscription: Subscription, filter2hourMembership: boolean): Subscription {
  if (!filter2hourMembership) {
    return subscription;
  }

  if (subscription.upgrade_downgrade_options?.hour_change_options) {
    const newHourChangeOptions = subscription.upgrade_downgrade_options.hour_change_options.filter(
      (option) =>
        !option.entitlements.some((entitlement) => entitlement.configuration.number_of_hours === 2)
    );

    return {
      ...subscription,
      upgrade_downgrade_options: {
        ...subscription.upgrade_downgrade_options,
        hour_change_options: newHourChangeOptions,
      },
    };
  }

  return subscription;
}

export default applyHourFilter;
